import { render, staticRenderFns } from "./CreateSabbaticalLeave.vue?vue&type=template&id=19bec717&scoped=true&"
import script from "./CreateSabbaticalLeave.vue?vue&type=script&lang=js&"
export * from "./CreateSabbaticalLeave.vue?vue&type=script&lang=js&"
import style0 from "./CreateSabbaticalLeave.vue?vue&type=style&index=0&id=19bec717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bec717",
  null
  
)

export default component.exports